import { Role } from '@/models/role';
import { axiosV2 } from '@/main';

class RoleWebservice {
    public get() {
        return axiosV2.get<{
            data: Role;
        }>('/role');
    }
}

export const roleWebservice = new RoleWebservice();
